import { render, staticRenderFns } from "./AddBudgetCost.vue?vue&type=template&id=0ba34d28&scoped=true&"
import script from "./AddBudgetCost.vue?vue&type=script&lang=js&"
export * from "./AddBudgetCost.vue?vue&type=script&lang=js&"
import style0 from "./AddBudgetCost.vue?vue&type=style&index=0&id=0ba34d28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba34d28",
  null
  
)

export default component.exports